import { render, staticRenderFns } from "./addTaskType.vue?vue&type=template&id=ae9d7386&scoped=true&"
import script from "./addTaskType.vue?vue&type=script&lang=js&"
export * from "./addTaskType.vue?vue&type=script&lang=js&"
import style0 from "./addTaskType.vue?vue&type=style&index=0&id=ae9d7386&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9d7386",
  null
  
)

export default component.exports